module.exports = __webpack_public_path__ + "static/media/mileage_2_5.a0f1a220.png";